import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { GamePage } from './game.page';

import { QuestionComponent } from '../question/question.component';

import { AppCommonModule } from '@common/app-common.module';

import { PlayersComponent } from '../players/players.component';

import { SwiperModule } from 'ngx-swiper-wrapper';
import { BrainGameCommonModule } from '@app/brain-game/braingameComponents.module';

const routes: Routes = [
  {
    path: '',
    component: GamePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    AppCommonModule,
    FormsModule,
    IonicModule,
    SwiperModule,
    BrainGameCommonModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    GamePage,
    QuestionComponent,
    PlayersComponent
  ]
})
export class GamePageModule {}
